'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _CartStore = require('../../../stores/CartStore');

var _CartStore2 = _interopRequireDefault(_CartStore);

var _MainStore = require('../../../stores/MainStore');

var _MainStore2 = _interopRequireDefault(_MainStore);

var _reflux = require('reflux');

var _reflux2 = _interopRequireDefault(_reflux);

var _CartItems = require('../CartItems.jsx');

var _CartItems2 = _interopRequireDefault(_CartItems);

var _CartPriceStructure = require('../CartPriceStructure.jsx');

var _CartPriceStructure2 = _interopRequireDefault(_CartPriceStructure);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CartItemsStructure = (0, _createReactClass2.default)({
    displayName: 'CartItemsStructure',


    mixins: [_reflux2.default.listenTo(_CartStore2.default, 'onChange')],

    getInitialState: function getInitialState() {
        return {
            orderType: ""
        };
    },
    UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
        var orderType = _CartStore2.default.getOrderType();
        this.setState({
            orderType: orderType
        });
    },
    UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {

        if (nextProps) {
            var orderType = _CartStore2.default.getOrderType();

            this.setState({
                orderType: _CartStore2.default.getOrderType()
            });
        }
    },
    onChange: function onChange(event, _cart) {
        this.setState({
            orderType: _CartStore2.default.getOrderType()
        });
    },
    handleShowModal: function handleShowModal(status) {
        this.setState({
            showModal: status
        });
    },
    render: function render() {

        var self = this;
        var component = _react2.default.createElement(
            'div',
            { className: 'col-md-5 scrollbar-width-thin mt-4  ' + (!this.state.showModal ? "cartright" : null) },
            _react2.default.createElement(
                'div',
                { id: 'cart-struct', className: 'checkOut-right bg-white rounded shadow-sm p-4 mb-4' },
                _react2.default.createElement(_CartItems2.default, {
                    callBackParent: this.handleShowModal,
                    isMobile: this.props.isMobile
                }),
                _react2.default.createElement(_CartPriceStructure2.default, {
                    orderType: this.state.orderType,
                    isLoggedInExistingUser: this.props.isLoggedInExistingUser,
                    history: this.props.history,
                    locId: this.props.locId
                })
            )
        );

        return component;
    }
});

exports.default = CartItemsStructure;


//////////////////
// WEBPACK FOOTER
// ./src/components/cart-view/cart-right/CartItemsStructure.jsx
// module id = 562
// module chunks = 0